import { useNavigate } from "react-router-dom";

function AuthLayout({ children }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#070707] flex flex-col">
      {/* Header */}
      <header className="px-6 md:px-10 py-6">
        <div
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-3 cursor-pointer"
        >
          <svg
            className="w-8 h-8"
            style={{
              animation: "spin 18s linear infinite",
              filter: "drop-shadow(0 0 6px rgba(255, 107, 0, 0.47))",
            }}
            viewBox="0 0 120 120"
          >
            <circle
              cx="60"
              cy="60"
              r="54"
              stroke="#FF6B00"
              strokeWidth="6"
              fill="none"
            />
            <circle
              cx="60"
              cy="60"
              r="38"
              stroke="#FF6B00"
              strokeWidth="1"
              fill="none"
              opacity="0.18"
            />
            <line
              x1="60"
              y1="6"
              x2="60"
              y2="52"
              stroke="#FF6B00"
              strokeWidth="5"
              strokeLinecap="square"
            />
            <line
              x1="60"
              y1="68"
              x2="60"
              y2="114"
              stroke="#FF6B00"
              strokeWidth="5"
              strokeLinecap="square"
            />
            <line
              x1="6"
              y1="60"
              x2="52"
              y2="60"
              stroke="#FF6B00"
              strokeWidth="5"
              strokeLinecap="square"
            />
            <line
              x1="68"
              y1="60"
              x2="114"
              y2="60"
              stroke="#FF6B00"
              strokeWidth="5"
              strokeLinecap="square"
            />
            <line
              x1="22"
              y1="22"
              x2="52"
              y2="52"
              stroke="#FF9A3C"
              strokeWidth="3"
              strokeLinecap="square"
            />
            <line
              x1="68"
              y1="68"
              x2="98"
              y2="98"
              stroke="#FF9A3C"
              strokeWidth="3"
              strokeLinecap="square"
            />
            <line
              x1="98"
              y1="22"
              x2="68"
              y2="52"
              stroke="#FF9A3C"
              strokeWidth="3"
              strokeLinecap="square"
            />
            <line
              x1="52"
              y1="68"
              x2="22"
              y2="98"
              stroke="#FF9A3C"
              strokeWidth="3"
              strokeLinecap="square"
            />
            <rect x="53" y="0" width="14" height="11" fill="#FF6B00" />
            <rect x="53" y="109" width="14" height="11" fill="#FF6B00" />
            <rect x="0" y="53" width="11" height="14" fill="#FF6B00" />
            <rect x="109" y="53" width="11" height="14" fill="#FF6B00" />
            <rect
              x="52"
              y="52"
              width="16"
              height="16"
              fill="#070707"
              stroke="#FF6B00"
              strokeWidth="2"
            />
            <rect x="54" y="54" width="5" height="5" fill="#FF6B00" />
            <rect x="61" y="54" width="5" height="5" fill="#FF9A3C" />
            <rect x="54" y="61" width="5" height="5" fill="#FF9A3C" />
            <rect x="61" y="61" width="5" height="5" fill="#FF6B00" />
          </svg>
          <span
            className="font-space text-xl tracking-tight text-text-primary"
            style={{ fontWeight: "800" }}
          >
            PIXRD
          </span>
        </div>
      </header>

      {/* Centered card area */}
      <main className="flex-1 flex items-center justify-center px-6 pb-12">
        <div
          className="w-full max-w-[420px]"
          style={{ animation: "fadeUp 0.6s ease-out" }}
        >
          {children}
        </div>
      </main>
    </div>
  );
}

export default AuthLayout;
